import { render, staticRenderFns } from "./ParamsFormList.vue?vue&type=template&id=579859c4"
import script from "./ParamsFormList.vue?vue&type=script&lang=js"
export * from "./ParamsFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports